<template>
	<div class="dorm-screen-page">
		<div class="bg" :style="{ backgroundImage: `url(${bgUrl})` }"></div>
		<div class="page_box">
			<div class="home">
				<!-- 未固定楼栋时才允许切换；URL 带 buildingId 则锁定 -->
				<div class="selects room-select" v-if="!buildingLocked && rooms.length">
					<div class="select">
						<el-popover v-model="roomShow" placement="right" width="160" trigger="click">
							<div class="switch" slot="reference">
								切换
								<i class="el-icon-sort"></i>
							</div>
							<div class="room-list">
								<div
									class="room-item"
									v-for="(item, index) in rooms"
									:key="item.id || index"
									@click="onRoomChange(index)"
								>{{ item.name }}</div>
							</div>
						</el-popover>
						<div class="value">{{ currentRoomName }}</div>
					</div>
				</div>

				<div class="top">
					<div class="title" :style="{ backgroundImage: `url(${topUrl})` }">
						<div class="value" :class="{ min: displayTitle.length > 14 }">
							{{ displayTitle }}
						</div>
					</div>
					<div class="top_right">
						<div class="day-bar">
							<span class="day-date">{{ dayDate }}</span>
							<span class="day-week">{{ dayWeek }}</span>
							<span class="day-live" v-if="!date">实时</span>
							<span class="day-back" v-else @click.stop="backToRealtime">回实时</span>
							<el-date-picker
								class="dorm-date-picker-ghost"
								v-model="pickedDate"
								type="date"
								size="mini"
								value-format="yyyy-MM-dd"
								:clearable="false"
								:editable="false"
								popper-class="dorm-date-popper"
								@change="onDatePick"
							/>
						</div>
					</div>
					<div class="top_time">{{ nowTime }}</div>
				</div>

				<div class="bottom">
					<div class="b_left">
						<div class="b_left_t">
							<DormKpiBoard :data="screenData || {}" />
						</div>
						<div class="b_left_b">
							<DormFloorGrid :category1="screenData && screenData.category1" />
						</div>
					</div>
					<div class="b_right">
						<div class="item">
							<DormScrollPanel panel-type="attention" :list="screenData ? (screenData.table1 || []) : null" />
						</div>
						<div class="item">
							<DormScrollPanel panel-type="leave" :list="screenData ? (screenData.table2 || []) : null" />
						</div>
						<div class="item">
							<DormScrollPanel panel-type="late" :list="screenData ? (screenData.table3 || []) : null" />
						</div>
						<div class="item">
							<DormScrollPanel panel-type="access" :list="screenData ? (screenData.table4 || []) : null" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="error_box" v-if="errorText">
			<div class="error">{{ errorText }}</div>
		</div>
	</div>
</template>

<script>
import { getDormBigScreenData } from '../api/modules/big-screen'
import { publicAssetUrl } from '@/utils/publicAssetUrl'
import DormKpiBoard from './dorm-screen/DormKpiBoard.vue'
import DormFloorGrid from './dorm-screen/DormFloorGrid.vue'
import DormScrollPanel from './dorm-screen/DormScrollPanel.vue'
import { formateDate, todayStr, deepFreeze } from './dorm-screen/dormScreenFormat'

export default {
	name: 'DormBigScreen',
	components: { DormKpiBoard, DormFloorGrid, DormScrollPanel },
	data() {
		return {
			departmentId: '0',
			buildingId: '',
			/** URL 带 buildingId 时锁定楼栋，不显示切换 */
			buildingLocked: false,
			date: '',
			type: '',
			isAdmin: 0,
			tvMode: true,
			/** TV 整页软重启间隔（毫秒），默认 60 分钟；可用 ?reloadMinutes=90 覆盖 */
			reloadEveryMs: 60 * 60 * 1000,
			screenData: null,
			errorText: '',
			timer: null,
			reloadTimer: null,
			fetchSeq: 0,
			roomShow: false,
			roomIndex: 0,
			pickedDate: '',
			dayDate: '',
			dayWeek: '',
			nowTime: '',
			clockTimer: null,
			nowDate: '',
		}
	},
	computed: {
		bgUrl() {
			return publicAssetUrl('static/dorm-screen/img/bg.jpg')
		},
		topUrl() {
			return publicAssetUrl('static/dorm-screen/img/top.png')
		},
		rooms() {
			return (this.screenData && this.screenData.rooms) || []
		},
		schoolName() {
			return (this.screenData && this.screenData.schoolName) || ''
		},
		currentRoomName() {
			const room = this.rooms[this.roomIndex]
			return room ? room.name : ''
		},
		/** 固定楼栋：学校名-楼栋；未固定：仅学校名 */
		displayTitle() {
			if (this.buildingLocked && this.schoolName && this.currentRoomName) {
				return `${this.schoolName}-${this.currentRoomName}`
			}
			return this.schoolName || ''
		},
	},
	mounted() {
		const query = this.$route.query || {}
		this.departmentId = query.departmentId || '99'
		if (this.departmentId === '0') this.departmentId = '99'
		this.buildingId = query.buildingId || ''
		this.buildingLocked = Boolean(this.buildingId && this.buildingId !== '0')
		this.date = query.date || ''
		this.type = query.type || ''
		this.isAdmin = Number(query.isAdmin || 0)
		this.tvMode = query.tv !== '0'
		const reloadMinutes = Number(query.reloadMinutes)
		if (reloadMinutes > 0) {
			this.reloadEveryMs = Math.max(10, reloadMinutes) * 60 * 1000
		}
		this.pickedDate = this.date || todayStr()
		this.nowDate = todayStr()
		this.refreshClock()
		this.clockTimer = setInterval(this.refreshClock, 1000)
		this.initData()
		this.scheduleHardReload()
	},
	beforeDestroy() {
		if (this.timer) clearTimeout(this.timer)
		if (this.reloadTimer) clearTimeout(this.reloadTimer)
		if (this.clockTimer) clearInterval(this.clockTimer)
	},
	methods: {
		/** TV 浏览器内存无法彻底压住，到期整页重载释放堆（勿按堆阈值即时 reload，开发态常>160MB 会死循环） */
		scheduleHardReload() {
			if (!this.tvMode) return
			if (this.reloadTimer) clearTimeout(this.reloadTimer)
			this.reloadTimer = setTimeout(() => {
				window.location.reload()
			}, this.reloadEveryMs)
		},
		refreshClock() {
			const now = new Date()
			this.nowTime = formateDate('HH:MM:SS', now)
			const today = todayStr()
			this.nowDate = today
			// 实时模式跟日历日；跨天时同步选择器显示
			if (!this.date && this.pickedDate !== today) {
				this.pickedDate = today
			}
			const d = this.date ? new Date(this.date.replace(/-/g, '/')) : now
			if (isNaN(d.getTime())) {
				this.dayDate = today
				this.dayWeek = ''
				return
			}
			this.dayDate = formateDate('YYYY-mm-dd', d)
			this.dayWeek = formateDate('W+', d)
		},
		/** 选日期后按历史日查询；始终展示具体日期 */
		onDatePick(val) {
			if (!val) {
				this.backToRealtime()
				return
			}
			this.date = val
			this.pickedDate = val
			this.refreshClock()
			this.initData()
		},
		/** 回到当天实时 */
		backToRealtime() {
			this.date = ''
			this.pickedDate = todayStr()
			this.refreshClock()
			this.initData()
		},
		onRoomChange(index) {
			if (this.buildingLocked) return
			this.roomShow = false
			this.roomIndex = index
			const room = this.rooms[index]
			this.buildingId = room ? String(room.id || '') : ''
			this.initData()
		},
		syncRoomIndex() {
			if (!this.rooms.length) {
				this.roomIndex = 0
				return
			}
			if (this.buildingId) {
				const idx = this.rooms.findIndex((r) => String(r.id) === String(this.buildingId))
				this.roomIndex = idx >= 0 ? idx : 0
				if (idx < 0 && this.rooms[0]) this.buildingId = String(this.rooms[0].id || '')
			} else {
				this.roomIndex = 0
			}
		},
		initData() {
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			}
			const today = todayStr()
			if (!this.nowDate) this.nowDate = today
			else if (this.nowDate !== today && !this.date) {
				window.location.reload()
				return
			}

			const params = {
				departmentId: this.departmentId,
				buildingId: this.buildingId || '0',
				type: this.type,
				date: this.date,
				isAdmin: this.isAdmin,
			}
			const seq = ++this.fetchSeq
			getDormBigScreenData(params)
				.then((data) => {
					// 过期请求丢弃，避免乱序覆盖 / 堆积回调
					if (seq !== this.fetchSeq) return
					if (data && data.success) {
						const normalized = this.normalizeDormScreenResponse(data.response || {})
						// 整包冻结：大屏只读展示，勿对宿舍树做 Vue 深度观察
						this.screenData = deepFreeze(normalized)
						this.errorText = (this.screenData && this.screenData.error) || ''
						this.syncRoomIndex()
					} else {
						this.screenData = null
						this.errorText = (data && data.msg) || '加载失败'
					}
				})
				.catch(() => {
					if (seq !== this.fetchSeq) return
					this.errorText = '网络异常，请稍后重试'
				})

			this.timer = setTimeout(() => {
				this.timer = null
				this.initData()
			}, 5 * 60 * 1000)
		},
		normalizeDormScreenResponse(response) {
			if (!response || !response.category1 || !Array.isArray(response.category1.list)) {
				return response
			}
			const resultName = (student) => {
				const code = student.currentResult || student.attendanceStatus || (
					student.eveningResult && student.eveningResult !== 'UNJUDGED'
						? student.eveningResult
						: student.morningResult
				)
				const names = {
					EXITED: '离寝',
					LATE_EXIT: '晚离',
					NOT_EXITED: '未离寝',
					RETURNED: '归寝',
					LATE_RETURN: '晚归',
					NOT_RETURNED: '未归寝',
					LEAVE: '请假',
					UNJUDGED: '未判定',
					NOT_CHECKED_IN: '未入住',
					NOT_APPLICABLE: '不适用',
				}
				return student.currentResultName || names[code] || '未判定'
			}
			const isRealtime = response.dataMode === 'REALTIME'
			response.category1.list.forEach((floor) => {
				;(floor || []).forEach((room) => {
					;((room && room.list) || []).forEach((student) => {
						if (!student) return
						student.overallAttendanceStatus = student.attendanceStatus
						const attendanceCode = student.currentResult || student.attendanceStatus
						const presenceNames = { IN_DORM: '在寝', OUT_DORM: '离寝' }
						const hasRealtimePresence = Boolean(presenceNames[student.presenceStatus])
						student.attendanceStatus = attendanceCode || student.presenceStatus || 'UNJUDGED'
						student.displayStatus = hasRealtimePresence
							? presenceNames[student.presenceStatus]
							: (isRealtime ? '无通行' : resultName(student))
					})
				})
			})
			return response
		},
	},
}
</script>

<style scoped>
.dorm-screen-page {
	position: relative;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	color: #fff;
	font-size: 0.94vw;
	user-select: none;
}
.bg {
	position: fixed;
	inset: 0;
	z-index: 1;
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.page_box {
	position: fixed;
	inset: 0;
	z-index: 20;
	box-sizing: border-box;
}
.home {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.selects {
	position: fixed;
	top: 0.52vw;
	right: 2.08vw;
	z-index: 40;
}
.room-select {
	left: 2.08vw;
	right: auto;
}
.select {
	display: flex;
	align-items: center;
	font-size: 1.25vw;
	height: 2.08vw;
}
.switch {
	color: #2d75fa;
	font-size: 0.94vw;
	margin-right: 1.5vw;
	cursor: pointer;
}
.top {
	position: relative;
	width: 100%;
}
.title {
	display: flex;
	width: 100%;
	height: 5.2vw;
	justify-content: center;
	background-position: center 0;
	background-repeat: no-repeat;
	background-size: cover;
}
.title .value {
	line-height: 3.5vw;
	font-size: 1.98vw;
	font-weight: 900;
	background: linear-gradient(to top, #00e2fb8f, #00e2fb);
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}
.title .value.min {
	font-size: 1.56vw;
}
.top_right {
	position: absolute;
	left: 0;
	right: 0;
	top: 3.05vw;
	margin: auto;
	width: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 30;
}
.day-bar {
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 0.4vw;
	padding: 0.12vw 0.7vw;
	border-radius: 0.25vw;
	background: rgba(8, 24, 64, 0.55);
	border: 1px solid rgba(56, 189, 248, 0.35);
	box-shadow: inset 0 0 0.6vw rgba(45, 117, 250, 0.12);
	cursor: pointer;
}
.day-date {
	font-size: 0.84vw;
	font-weight: 600;
	letter-spacing: 0.04em;
	color: #e2e8f0;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}
.day-week {
	font-size: 0.78vw;
	color: #7dd3fc;
	white-space: nowrap;
}
.day-live,
.day-back {
	position: relative;
	z-index: 2;
	font-size: 0.62vw;
	line-height: 1;
	padding: 0.18vw 0.35vw;
	border-radius: 0.2vw;
	white-space: nowrap;
}
.day-live {
	color: #67e8f9;
	background: rgba(34, 211, 238, 0.15);
	border: 1px solid rgba(34, 211, 238, 0.4);
}
.day-back {
	color: #93c5fd;
	background: rgba(59, 130, 246, 0.18);
	border: 1px solid rgba(96, 165, 250, 0.45);
	cursor: pointer;
}
.day-back:hover {
	color: #fff;
	border-color: rgba(125, 211, 252, 0.8);
}
/* 透明覆盖在日期条上，点击即弹出选择器 */
.dorm-date-picker-ghost {
	position: absolute !important;
	left: 0;
	top: 0;
	width: 100% !important;
	height: 100%;
	opacity: 0;
	z-index: 1;
}
.dorm-date-picker-ghost >>> .el-input,
.dorm-date-picker-ghost >>> .el-input__inner {
	height: 100%;
	cursor: pointer;
}
.top_time {
	position: absolute;
	right: 2.2vw;
	/* 略上移，避开顶栏装饰横线 */
	top: 0.35vw;
	z-index: 40;
	font-size: 1.55vw;
	line-height: 1.2;
	font-weight: 700;
	letter-spacing: 0.06em;
	color: #7dd3fc;
	font-variant-numeric: tabular-nums;
	text-shadow: 0 0 0.4vw rgba(56, 189, 248, 0.35);
	padding: 0.15vw 0.4vw;
	border-radius: 0.2vw;
	background: rgba(2, 12, 36, 0.35);
}
.bottom {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 5.2vw 0.52vw 1.3vw;
}
.b_left {
	width: calc(60% - 0.52vw);
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.b_left_t {
	height: 20%;
}
.b_left_b {
	height: calc(80% - 0.52vw);
}
.b_right {
	width: 40%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.b_right .item {
	width: calc(50% - 0.26vw);
	height: calc(50% - 0.26vw);
	margin-bottom: 0.52vw;
}
.error_box {
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.55);
	z-index: 99;
}
.error {
	color: #1e90ff;
	font-size: 1.56vw;
	padding: 1.5vw 3vw;
	border: 1px solid #1e90ff;
	background: rgba(30, 144, 255, 0.1);
}
.room-list .room-item {
	padding: 0.6vw 0.8vw;
	text-align: center;
	cursor: pointer;
	border-bottom: 1px solid rgba(30, 144, 255, 0.35);
}
.room-list .room-item:hover {
	background: rgba(30, 144, 255, 0.35);
	color: orange;
}
</style>

<!-- 日期面板挂到 body，需非 scoped 暗色样式 -->
<style>
.dorm-date-popper.el-picker-panel {
	background: #0b1630;
	border: 1px solid rgba(56, 189, 248, 0.45);
	color: #e2e8f0;
	box-shadow: 0 0.4vw 1.2vw rgba(0, 0, 0, 0.55);
}
.dorm-date-popper.el-popper[x-placement^='bottom'] .popper__arrow::after {
	border-bottom-color: #0b1630;
}
.dorm-date-popper.el-popper[x-placement^='bottom'] .popper__arrow {
	border-bottom-color: rgba(56, 189, 248, 0.45);
}
.dorm-date-popper.el-popper[x-placement^='top'] .popper__arrow::after {
	border-top-color: #0b1630;
}
.dorm-date-popper.el-popper[x-placement^='top'] .popper__arrow {
	border-top-color: rgba(56, 189, 248, 0.45);
}
.dorm-date-popper .el-date-picker__header-label,
.dorm-date-popper .el-picker-panel__icon-btn {
	color: #7dd3fc;
}
.dorm-date-popper .el-picker-panel__icon-btn:hover,
.dorm-date-popper .el-date-picker__header-label:hover {
	color: #fff;
}
.dorm-date-popper .el-date-table th {
	color: #94a3b8;
	border-bottom-color: rgba(56, 189, 248, 0.2);
}
.dorm-date-popper .el-date-table td {
	color: #e2e8f0;
}
.dorm-date-popper .el-date-table td.next-month,
.dorm-date-popper .el-date-table td.prev-month {
	color: #64748b;
}
.dorm-date-popper .el-date-table td.available:hover span {
	background: rgba(43, 107, 243, 0.4);
	color: #fff;
}
.dorm-date-popper .el-date-table td.today span {
	color: #67e8f9;
	font-weight: 700;
}
.dorm-date-popper .el-date-table td.current:not(.disabled) span {
	background: #2b6bf3 !important;
	color: #fff !important;
}
.dorm-date-popper .el-year-table td .cell,
.dorm-date-popper .el-month-table td .cell {
	color: #e2e8f0;
}
.dorm-date-popper .el-year-table td .cell:hover,
.dorm-date-popper .el-month-table td .cell:hover,
.dorm-date-popper .el-year-table td.current:not(.disabled) .cell,
.dorm-date-popper .el-month-table td.current:not(.disabled) .cell {
	color: #67e8f9;
}
</style>
